import React from "react";
import {
  PREMIUM_PACKAGE_VIDEO_SRC,
  STANDARD_PACKAGE_VIDEO_SRC,
} from "./media-video";
import { scrollToPropertyFeaturedForm, PROPERTY_FEATURED_FORM_ID } from "./scroll-to-featured-form";
import "./styles.css";

const standardFeatures = [
  "Professional property photography",
  "Standard video walkthrough",
  "Social media promotion",
  "Listing optimisation",
  "Audience targeting campaign",
  "Monthly performance report",
];

const premiumFeatures = [
  { text: "Everything in Standard, plus", highlight: true },
  { text: "Cinematic property video" },
  { text: "Drone aerial footage" },
  { text: "Premium property showcase campaign" },
  { text: "Featured placement across Krent channels" },
  { text: "Extended audience reach" },
  { text: "Lead qualification support" },
  { text: "Dedicated Krent Property Advisor" },
  { text: "Enhanced reporting and insights" },
];

const PackageVideo = ({ variant }: { variant: "standard" | "premium" }) => (
  <div className={`package-video ${variant}`}>
    <p className="package-video-label">VIDEO EXAMPLE</p>
    <div className="package-video-wrapper">
      <video
        src={
          variant === "standard"
            ? STANDARD_PACKAGE_VIDEO_SRC
            : PREMIUM_PACKAGE_VIDEO_SRC
        }
        controls
        playsInline
        preload="metadata"
      />
    </div>
  </div>
);

const WhatWeOfferSection = () => {
  return (
    <section className="what-we-offer">
      <div className="property-featured-container">
        <div className="what-we-offer-header">
          <h2 className="what-we-offer-title font-onest">WHAT WE OFFER:</h2>
          <p className="what-we-offer-subtitle font-onest">
            Choose Your Visibility Package.
          </p>
        </div>

        <div className="what-we-offer-cards">
          <article className="package-card package-card-standard font-onest">
            <span className="package-badge package-badge-muted">
              STANDARD PACKAGE
            </span>
            <h3 className="package-name font-onest">Standard</h3>
            <p className="package-description font-onest">
              Perfect for property owners looking to increase visibility and
              attract more qualified inquiries.
            </p>
            <hr />

            <p className="package-includes-label font-onest">INCLUDES</p>
            <ul className="package-features font-onest">
              {standardFeatures.map((feature) => (
                <li key={feature}>
                  <i className="fa-solid fa-check" />
                  <span>{feature}</span>
                </li>
              ))}
            </ul>

            <PackageVideo variant="standard" />

            <a
              href={`#${PROPERTY_FEATURED_FORM_ID}`}
              className="package-cta package-cta-outline font-onest"
              onClick={scrollToPropertyFeaturedForm}
            >
              Book Your Shoot
            </a>
          </article>

          <article className="package-card package-card-premium font-onest">
            <div className="package-premium-top">
              <span className="package-badge package-badge-light">
                PREMIUM PACKAGE
              </span>
              <span className="package-popular-badge font-onest ">
                MOST POPULAR
              </span>
            </div>
            <h3 className="package-name font-onest">Premium</h3>
            <p className="package-description font-onest">
              Perfect for developers, luxury property owners, commercial
              managers, and high-value listings.
            </p>
            <hr />

            <p className="package-includes-label font-onest">INCLUDES</p>
            <ul className="package-features font-onest      ">
              {premiumFeatures.map((feature) => (
                <li
                  key={feature.text}
                  className={feature.highlight ? "highlight" : ""}
                >
                  <i className="fa-solid fa-check" />
                  <span>{feature.text}</span>
                </li>
              ))}
            </ul>

            <PackageVideo variant="premium" />

            <a
              href={`#${PROPERTY_FEATURED_FORM_ID}`}
              className="package-cta package-cta-solid font-onest"
              onClick={scrollToPropertyFeaturedForm}
            >
              Book Your Shoot
            </a>
          </article>
        </div>
      </div>
    </section>
  );
};

export default WhatWeOfferSection;
